import React from 'react';

const CheckIcon = ({color="#0097FF"}) => {
  return(
    <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 8.5L2.5 6.5L7.5 11.5L18.5 0.5L20.5 2.5L7.5 15.5L0.5 8.5Z" fill={color} />
    </svg>
  )
}

export default CheckIcon